import { parseAsync } from 'json2csv'

export default function json2csv(fields, data) {  
  return parseAsync(data, { fields })
}